import { chakra } from '@chakra-ui/react';
import { statusColorFromSensorStatus } from '@components/cockpit/panels/monitoring/monitoring.utils';
import { colors } from '@theme/foundations/colors';

import { HealthStatusEnum } from '@/types/sensor/sensors';

type Props = {
  trigram: string;
  x: number;
  y: number;
  status?: HealthStatusEnum;
};

const Text = chakra('text');

export default function TrigramInfo({ trigram, x, y, status }: Readonly<Props>) {
  const statusColor = status ? statusColorFromSensorStatus[status] : colors.neutral['500'].value;
  return (
    <svg width="46" height="19" x={x} y={y} viewBox="0 0 46 19">
      <rect width="46" height="19" fill={colors.neutral[status ? '100' : '300'].value} />
      <Text x="4" y="14.5" fill={colors.neutral.black.value}>
        {trigram}
      </Text>
      {status && (
        <rect
          opacity="0.5"
          x={31}
          y={4.5}
          width="10"
          height="10"
          stroke={statusColor}
          strokeWidth="2"
          strokeLinejoin="bevel"
        />
      )}
      <rect x={32} y={5.5} width="8" height="8" fill={statusColor} />
    </svg>
  );
}
